import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentLoadDemurrageAndDetentionInfoService } from './shipment-load-demurrage-and-detention-info.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import {
  ShipmentLoadDemurrageAndDetentionInfoLoad,
  ShipmentLoadDemurrageAndDetentionInfoSetInitialState,
} from './shipment-load-demurrage-and-detention-info.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import {
  ShipmentLoadDemurrageAndDetention,
  ShipmentLoadDemurrageAndDetentionContainer,
  ShipmentLoadDemurrageAndDetentionSummary,
} from '../../models';

export interface ShipmentLoadDemurrageAndDetentionInfoStateModel {
  demurrageAndDetention: ShipmentLoadDemurrageAndDetention;
  loaded: boolean;
}

const initialState: ShipmentLoadDemurrageAndDetentionInfoStateModel = {
  demurrageAndDetention: null,
  loaded: false,
};

@State<ShipmentLoadDemurrageAndDetentionInfoStateModel>({
  name: 'shipmentLoadDemurrageAndDetentionInfo',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadDemurrageAndDetentionInfoState {
  constructor(
    private shipmentLoadOverviewService: ShipmentLoadDemurrageAndDetentionInfoService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getLoaded(state: ShipmentLoadDemurrageAndDetentionInfoStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getSummary(state: ShipmentLoadDemurrageAndDetentionInfoStateModel): ShipmentLoadDemurrageAndDetentionSummary {
    return state.demurrageAndDetention.summary;
  }

  @Selector()
  static getDestination(
    state: ShipmentLoadDemurrageAndDetentionInfoStateModel,
  ): ShipmentLoadDemurrageAndDetentionContainer {
    return state.demurrageAndDetention.destination;
  }

  @Selector()
  static getOrigin(state: ShipmentLoadDemurrageAndDetentionInfoStateModel): ShipmentLoadDemurrageAndDetentionContainer {
    return state.demurrageAndDetention.origin;
  }

  @Action(ShipmentLoadDemurrageAndDetentionInfoLoad)
  getDemurrageAndDetentionInfo(
    ctx: StateContext<ShipmentLoadDemurrageAndDetentionInfoStateModel>,
    { payload }: ShipmentLoadDemurrageAndDetentionInfoLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadOverviewService.getInfoData(payload).pipe(
      map((demurrageAndDetention: ShipmentLoadDemurrageAndDetention) => {
        ctx.patchState({ demurrageAndDetention, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadDemurrageAndDetentionInfoSetInitialState)
  setInitialState(ctx: StateContext<ShipmentLoadDemurrageAndDetentionInfoStateModel>): void {
    ctx.setState(initialState);
  }
}
